import React, { useState, useEffect, useCallback, useMemo } from "react";

import { Box,Tooltip } from "@mui/material";
import ReusableMuiTable from "../../components/common/Table/Table";
import { getContactList } from "../../api/auth/auth";

const ContactList = () => {


  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchText, setSearchText] = useState(""); 


  const fetchContacts = useCallback(async (search = "") => {
    try {
      setLoading(true);
      const res = await getContactList({ search, limit: 10, page });
      const data = res?.data;
      setContacts(data?.data || []);
      setTotalPages(data?.last_page || 1);
    } catch (error) {
      console.error("Failed to fetch contacts:", error);
    } finally {
      setLoading(false);
    }
  }, [page]);


  useEffect(() => {
    fetchContacts(searchText);
  }, [fetchContacts, searchText]);


  const columns = useMemo(() => [
    { name: "name", label: "Name" },
    { name: "email", label: "Email" },
    { name: "phone_number", label: "Phone" },
    { name: "company_name", label: "Company" },
    {
      name: "message",
      label: "Message",
      options: {
        customBodyRender: (value) => (
          <Tooltip title={value}>
            <Box
              sx={{
                maxWidth: "250px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer",
              }}
            >
              {value}
            </Box>
          </Tooltip>
        ),
      },
    },
  ], []);

  return (
    <Box>
      <ReusableMuiTable
        title="Contact List"
        data={contacts}
        columns={columns}
        loading={loading}
        options={{
          page: page - 1,
          count: totalPages * 10,
          rowsPerPage: 10,
          onChangePage: (newPage) => setPage(newPage + 1),
          searchText: searchText,
          onSearchChange: (text) => {
            setSearchText(text);
            setPage(1); 
          },
        }}
    
      />
    </Box>
  );
};

export default ContactList;
